// Deprecated. Please refrain from new usage
import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";

import { withStyles, withTheme } from "@material-ui/core/styles";
import Refresh from "@material-ui/icons/Refresh";

import { DateService } from "../../services/dates.service";
import Typography from "../Helpers/Typography";

const styles = (theme) => ({
  refresh: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.secondary,
    width: "100%",
    justifyContent: "center",
    height: 48,
  },
  lastUpdated: {
    display: "inline-flex",
    paddingLeft: 10,
  },
  refreshButtonContainer: {
    paddingLeft: 5,
    marginTop: 10,
    display: "inline-flex",
  },
  refreshButton: {
    position: "absolute",
    marginTop: -20,
  },
  refreshIcon: {
    height: 20,
    paddingLeft: 10,
    cursor: "pointer",
  },
  refreshText: {
    display: "inline-flex",
    margin: 0,
  },
  root: {
    position: "relative",
    height: 48,
    display: "flex",
    alignItems: "center",
    background: "#000",
    margin: "auto",
  },
});

export const LastRefreshed = (props) => {
  const { classes, t, time } = props;

  return (
    <div className={classes.root}>
      <div className={classes.refresh}>
        {time ? (
          <>
            <Typography className={classes.refreshText} color="secondary">
              {t("Vehicles.Detail.History.LastUpdated")}
              <span className={classes.lastUpdated}>
                {DateService.format(time, "hh:mm:ss MM/DD")}
              </span>
            </Typography>
            <Refresh className={classes.refreshIcon} onClick={props.handleClick} />
          </>
        ) : (
          <Typography className={classes.refreshText} color="secondary">
            <i>{t("Vehicles.Detail.History.Updating")}</i>
          </Typography>
        )}
      </div>
    </div>
  );
};

LastRefreshed.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  time: PropTypes.instanceOf(Date),
  handleClick: PropTypes.func.isRequired,
};

LastRefreshed.defaultProps = {
  time: null,
};

export default withTranslation("common")(withStyles(styles)(withTheme(LastRefreshed)));
